<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div v-if="data" class="text-danger">
      <i class="fa fa-warning"></i>
      <span class="text-capitalize-first">{{ helper.trans(`antifraudalerts.description.${alert.rule}.default`, {count: data.fakeCount, limit: data.limit}) }}</span>
    </div>
    <div v-if="data" class="small text-secondary mt-1">
      <span class="text-capitalize-first">{{ helper.trans(`antifraudalerts.description.${alert.rule}.deal`) }}:</span>
      <span class="ms-1">{{ data.dealId }}</span>
      <copy-button :value="data.dealId"></copy-button>
    </div>
    <div v-if="data && data.verdicts.length > 0" class="small text-secondary">
      <span class="text-capitalize-first">{{ helper.trans(`antifraudalerts.description.${alert.rule}.verdicts`) }}:</span>
      <span class="ms-1">{{ data.verdicts.map((verdict) => helper.trans(`stopscam.verdict.${verdict}`, {}, verdict)).join(', ') }}</span>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import CopyButton from "@/components/CopyButton.vue";
import PayOutStopScamReceiptCheckDataDTO from "@/models/AntiFraud/PayOutStopScamReceiptCheckDataDTO";

export default defineComponent({
  name: "PayOutStopScamReceiptCheckDescription",
  components: {
    CopyButton
  },
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): PayOutStopScamReceiptCheckDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as PayOutStopScamReceiptCheckDataDTO
    })

    return {
      helper,
      data
    }
  }
})
</script>
